import { render, staticRenderFns } from "./PlaceTabs.vue?vue&type=template&id=6c38aeea&"
import script from "./PlaceTabs.vue?vue&type=script&lang=js&"
export * from "./PlaceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports